import React from "react";
import { Container, Row, Col, Image, ListGroup, Item } from "react-bootstrap";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import { TextField, Button, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Form } from "react-bootstrap";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import PageCover from "../Components/Shared/PageCover";
import bookCover from "../Components/Assets/Images/bookingCover.jpg";
import bgDots from "../Components/Assets/Images/bgDots.png";
import gorakhpur from "../Components/Assets/Images/gorakhpur.jpg";
import noida from "../Components/Assets/Images/noida.jpeg";
import lucknow from "../Components/Assets/Images/lucknow.jpg";
import planeNose from "../Components/Assets/Images/planeNoseHalf.jpg";
import mobileeffect from "../Components/Assets/Images/cardBook.png";

const BookNow = () => {
  const [departing, setDeparting] = useState(null);
  const [returning, setReturning] = useState(null);
  const [showCounter, SetShowCounter] = useState(false);
  const [adults, setAdults] = useState(0);
  const [childs, setChilds] = useState(0);
  const [infant, setInfant] = useState(0);
  const [tripType, setTripType] = useState("round-trip");

  const increase = (setter, value, e) => {
    e.preventDefault();
    if (value < 8) setter(value + 1);
  };
  const decrease = (setter, value, e) => {
    e.preventDefault();
    if (value > 0) {
      setter(value - 1);
    }
  };
  const passengerCounter = () => {
    SetShowCounter(!showCounter);
  };
  const tripChange = (e) => {
    setTripType(e.target.value);
  };
  useEffect(() => {
    const ClickOutside = (event) => {
      if (!event.target.closest(".passengers")) {
        SetShowCounter(false);
      }
    };

    document.addEventListener("click", ClickOutside);
    return () => document.removeEventListener("click", ClickOutside);
  }, []);
  return (
    <>
      <motion.div
        initial={{ y: -150, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: true }}
      >
        <PageCover
          image={bookCover}
          title="Book Now"
          subtitle="Welcome to Our World, Where Innovation Meets Purpose, and Possibilities Unfold"
        />
      </motion.div>
      <Box
        style={{ position: "relative", backgroundColor: "#eff8ff" }}
        id="bookNow"
      >
        <Box className="">
          <Container>
            <Row>
              <Col lg={12} sx={{cursor: "not-allowed"}}>
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.9, ease: "easeInOut" }}
                  viewport={{ once: true }}
                >
                  <Form
                    className="bookFrom p-0"
                    style={{ position: "relative", top: "-70px", zIndex: "1", pointerEvents: "none"}}
                    disabled
                  >
                    <Row
                      className="mb-3 pt-3"
                      style={{
                        backgroundImage: `url(${bgDots})`,
                        backgroundSize: "20%",
                        backgroundColor: "#ecf0f3",
                        boxShadow:
                          "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
                      }}
                    >
                      <Col lg="12" className="mb-4">
                        <FormControl>
                          <RadioGroup
                            row
                            value={tripType}
                            onChange={tripChange}
                            name="trip-type"
                          >
                            <FormControlLabel
                              value="oneway"
                              control={<Radio />}
                              label="Oneway"
                            />
                            <FormControlLabel
                              value="round-trip"
                              control={<Radio color="success" />}
                              label="Round Trip"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Col>
                      <Col lg={2} md={6} sm={12} className="mb-3">
                        <TextField
                          id="outlined-basic"
                          fullWidth
                          className="bookTextfield"
                          label="Fly From "
                          variant="outlined"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12} className="mb-3">
                        <TextField
                          id="outlined-basic"
                          fullWidth
                          label="Fly To"
                          className="bookTextfield"
                          variant="outlined"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12} className="mb-3 dateWidth">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Departing"
                            value={departing}
                            className="bookTextfield"
                            onChange={(newValue) => setDeparting(newValue)}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </Col>
                      <Col lg={2} md={6} sm={12} className="mb-3 dateWidth">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Returning"
                            disabled={tripType === "oneway"}
                            value={returning}
                            className="bookTextfield"
                            onChange={(newValue) => setReturning(newValue)}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </Col>
                      <Col lg={2} className="passengers">
                        <Box className="counts" onClick={passengerCounter}>
                          <Box>
                            <span>{adults} Adults</span>
                            <span>{childs} Childs </span>
                            <span>{infant} Infants </span>
                          </Box>
                        </Box>
                        <Box
                          className={`selector ${showCounter ? "show" : ""}`}
                        >
                          <Box className="counterBtn">
                            <span>
                              Adults <small>(Aged 12+ yrs)</small>
                            </span>
                            <button
                              onClick={(e) => increase(setAdults, adults, e)}
                              disabled={adults >= 8}
                              className=" increment adult+"
                            ></button>
                            <span class="fw-500">{adults}</span>
                            <button
                              onClick={(e) => decrease(setAdults, adults, e)}
                              disabled={adults <= 0}
                              className="decrement adult-"
                            ></button>
                          </Box>
                          <Box className="counterBtn">
                            <span>
                              Childrens <small>(2 - 12 yrs)</small>
                            </span>
                            <button
                              onClick={(e) => increase(setChilds, childs, e)}
                              disabled={childs >= 8}
                              className=" increment child+"
                            ></button>
                            <span class="fw-500">{childs}</span>
                            <button
                              onClick={(e) => decrease(setChilds, childs, e)}
                              disabled={childs <= 0}
                              className="decrement child-"
                            ></button>
                          </Box>
                          <Box className="counterBtn">
                            <span>
                              Infants <small>(Below 2 yrs)</small>
                            </span>
                            <button
                              onClick={(e) => increase(setInfant, infant, e)}
                              disabled={infant >= 8}
                              className=" increment infant+"
                            ></button>
                            <span class="fw-500">{infant}</span>
                            <button
                              onClick={(e) => decrease(setInfant, infant, e)}
                              disabled={infant <= 0}
                              className="decrement infant+"
                            ></button>
                          </Box>
                        </Box>
                      </Col>
                      <Col lg={2}>
                        <Box className="btnWrapper text-end btnResp">
                          <Button
                            variant="link"
                            className="coverBtn bg-orange btnIcon text-nowrap"
                          >
                            <span>
                              Book Now{" "}
                              <FontAwesomeIcon icon={faPlaneDeparture} />
                            </span>
                          </Button>
                        </Box>
                      </Col>
                    </Row>
                  </Form>
                </motion.div>
              </Col>
            </Row>
          </Container>
        </Box>
      </Box>
      <Box style={{ backgroundColor: "#eff8ff" }}>
        <Container className="py-5">
          <Row className="g-0">
            <Col lg={12}>
              <Box className="mb-4 handpickText">
                <Typography variant="h6">
                  What’s your next dream destination? Discover handpicked routes
                </Typography>
                <Typography variant="h2">
                  Our exclusive low-fare routes with exceptional savings are
                  designed to make your journey <span>hassle-free</span> and
                  more{" "}
                  <span style={{ backgroundColor: "#ff621f" }}>affordable</span>
                </Typography>
              </Box>
            </Col>
            <Col lg={4} className="mb-lg-0 mb-4">
              <Box className="pickRoute">
                <Box
                  className="routeCard"
                  style={{ backgroundImage: `url(${gorakhpur})` }}
                >
                  <Box className="routeBoxText">
                    <Typography variant="h2" className="fw-500">
                      Fly To Hyderabad
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      Ticket Fares starting at ₹3,500
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Col>

            <Col lg={4} className="mb-lg-0 mb-4">
              <Box className="pickRoute">
                <Box
                  className="routeCard"
                  style={{ backgroundImage: `url(${noida})` }}
                >
                  <Box className="routeBoxText">
                    <Typography variant="h2" className="fw-500">
                      Fly To Noida
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      Ticket Fares starting at ₹2,95 0
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Col>

            <Col lg={4} className="mb-lg-0 mb-4">
              <Box className="pickRoute">
                <Box
                  className="routeCard"
                  style={{ backgroundImage: `url(${lucknow})` }}
                >
                  <Box className="routeBoxText">
                    <Typography variant="h2" className="fw-500">
                      Fly To Lucknow
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      Ticket Fares starting at ₹2,800
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Col>
          </Row>
        </Container>
      </Box>
      <Row as="section" className="dualsection">
        <Col lg={6} md={12} sm={12}>
          <Image
            className="img-fluid"
            src={planeNose}
            style={{ height: "100%", objectFit: "cover" }}
          ></Image>
        </Col>
        <Col lg={6} md={12} sm={12}>
          <Box className="p-4">
            <Typography
              variant="h6"
              style={{
                color: "#1b3043",
                fontSize: "32px",
                marginBottom: "12px",
                textTransform: "capitalize",
                fontWeight: 500,
              }}
            >
              Advantages of Flying with Shankh air?
            </Typography>
            <ListGroup as="ul" numbered className="list-unstyled">
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Passenger-First Philosophy Every decision we make is centered
                around your comfort, safety, and satisfaction.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Seamless Booking Experience Fast, user-friendly platform with
                instant confirmations, secure payments, and real-time seat
                selection.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Affordable Fares, Premium Service Enjoy high-quality onboard
                experience without compromising on budget.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                On-Time Performance We prioritize punctuality to ensure your
                plans stay right on schedule.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Expanding Route Network Thoughtfully selected destinations that
                connect growing cities, regional hubs, and emerging markets.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Exceptional Crew & Hospitality Trained professionals dedicated
                to providing warm, attentive, and personalized service
                throughout your journey.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Modern Fleet, Comfortable Travel Enjoy well-maintained aircraft
                equipped for safety, comfort, and reliability.
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                style={{ border: "none", padding: "0 0 8px 0 " }}
              >
                Strong Regional Focus Strengthening connectivity across
                underserved regions, making air travel more
                accessible.Transparent Policies No hidden charges, clear fare
                structures, and reliable customer support.
              </ListGroup.Item>
            </ListGroup>
          </Box>
        </Col>
      </Row>
      <Box className="card-effect" sx={{padding: '60px 0 0 0 ', backgroundColor: '#d9e9fc'}}>
        <Container>
          <Row>
            <Col lg={7} md={7} sm={12}>
              <Typography
                variant="h2"
                gutterBottom
              >
                You Can Book Tickets By card <br />
                Instant Booking Confirmation
              </Typography>

              <Typography variant="body1" >
                Get your ticket and e‑confirmation within seconds of payment.
              </Typography>

              <Typography variant="body1">
                24/7 Booking Access
              </Typography>

              <Typography variant="body1">
                Secure Transactions
              </Typography>

              <Typography variant="body1">
                Payments are encrypted and protected by OTPs, PINs, or biometric
                authentication.
              </Typography>

              <Typography variant="body1">
                Rewards & Cashback
              </Typography>

              <Typography variant="body1">
                Earn airline miles, loyalty points, or cashback with every
                flight purchase.
              </Typography>

              <Typography variant="body1">
                Canceled tickets are automatically refunded back to your card
                with tracking. Travel Insurance Coverage—many cards offer
                complimentary travel insurance when you use them to book
                flights. Saved Details for Faster Checkout—save your card
                securely for one‑click future bookings and auto‑reminders.
              </Typography>
            </Col>
            <Col lg={5} md={5} sm={12}>
              <Box className="img-fluid" component="img" src={mobileeffect} alt="Card" />
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default BookNow;
